

define(['squid/index', './directive'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-member-sepa.sepaMandate.route', ['squid', 'xo-member-sepa.sepaMandate.directive']).factory('$XOSepaMandateRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('XOSepaMandateRoute', {
            name: 'sepaMandate',

            directive: 'xo-sepa-mandate',
            titleContent: 'directDebitAgreement.ddFullAgreementTitle',

            trackingData: {
                fptiState: 'sepa_mandate'
            },

            loginRequired: true,

            children: []
        });
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/member-sepa/sepaMandate/route.js
 ** module id = 429
 ** module chunks = 1
 **/